import React, { useEffect, useState } from "react";
import "./LandingPage.scss";
import { Link, useNavigate } from "react-router-dom";
import FormInfoTable from "./FormInfoTable";
import axios from "axios";
import ClearIcon from "@mui/icons-material/Clear";
import Footer from "../../reusables/Footer";
import { useSetRecoilState } from "recoil";
import { formId } from "../../../store/atoms";
import { getToken } from "../../auth/authConfig";
import { Alert, Box, CircularProgress, Modal } from "@mui/material";
import { login } from "../../auth/msalAuth";

const LandingPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [unitFormList, setUnitFormList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [getLoading, setGetLoading] = useState(true);
  const [getError, setGetError] = useState(null);
  const setFormId = useSetRecoilState(formId);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [error, setError] = useState(false);

  // console.log("unitFormList", unitFormList);

  const email = localStorage.getItem("myemail");
  const createFormId = `${process.env.REACT_APP_SERVER_URL}/form/init`;

  const getUnitDetails = async () => {
    const unitDetailsUrl = `${process.env.REACT_APP_SERVER_URL}/form/list_unit_forms`;
    const token = await getToken();
    try {
      // Make GET request to your API
      const response = await axios.get(unitDetailsUrl, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      // console.log("User Data: ", response);

      if (response.status === 200) {
        // Set the fetched data to the state
        setUnitFormList(response.data);
        setFilteredData(response.data);
        setGetLoading(false);
      } else if (response.status === 401) {
        setError(true);
        setTimeout(() => setError(false), 3000);
      } else {
        setGetError("Oops! Something went wrong. . .");
      }
    } catch (e) {
      // If an error occurs, set the error state
      setGetLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setGetError("Oops! Something went wrong. . .");
    } finally {
      // Set loading state to false
      setGetLoading(false);
    }
  };

  const getFormId = async () => {
    const token = await getToken();

    try {
      setModalOpen(true);
      const { data } = await axios.get(createFormId, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (data?.formId) {
        setFormId(data.formId);
        localStorage.setItem("formId", data.formId);
        setModalOpen(false);
        window.location.href = `/audit/form?auditNumber=${data.formId}`;
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      // setError(true);
      // setTimeout(() => setError(false),3000)
      console.log("getting error in api");
      setModalOpen(false);
    }
  };
  const search_parameters = ["segment", "uiut", "form_id"];

  let filteredDataFull = [];

  filteredDataFull =
    unitFormList &&
    unitFormList.filter((obj) => {
      return obj;
    });

  function search(filteredDataFull) {
    return filteredDataFull.filter((item) =>
      search_parameters.some((parameter) =>
        item[parameter]
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      )
    );
  }

  useEffect(() => {
    getUnitDetails();
  }, []);
  return (
    <>
      <div className="unitAdminLandingPage">
        <div className="new-audit-btn">
          <div className="new-audit-btn">
            {/* <Link to="/audit/form">  */}
            <Link>
              <button onClick={getFormId} className="audit-btn">
                Fill New Audit Form
              </button>
            </Link>
          </div>
        </div>
        <FormInfoTable
          loading={getLoading}
          error={getError}
          tableData={unitFormList || []}
        />
      </div>
      <Modal open={modalOpen}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh", // Full viewport height
            width: "100%",
            flexDirection: "column",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            backdropFilter: "blur(5px)", // Adding a blur effect for the background
            borderRadius: "10px", // Rounded corners
            padding: "20px",
          }}
        >
          <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
          <h3 style={{ color: "white", fontSize: "18px", fontWeight: "500" }}>
            Loading... Please wait
          </h3>
        </Box>
      </Modal>
      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default LandingPage;
